
export enum StereotypeErrorCode {
    CONFLICTING_NAME = "CONFLICTING_NAME",
}